// Navbar and Footer data
import headerIcon from "../assets/headericon.svg";

export function getNavbarData() {
  return {
    logo: headerIcon,
    navLinks: [
      { path: "/", label: "Home" },
      { path: "/timetable", label: "Timetable" },
      { path: "/venue", label: "Venue" },
      { path: "/event", label: "Events" },
      { path: "/about-us", label: "About Us" },
    ],
    contactButton: {
      text: "Contact Us",
      path: "/contact"
    }
  };
}

export function getFooterData() {
  return {
    logo: headerIcon,
    description: "Transforming Lives Through Fitness Since 2009.",
    navLinks: [
      { path: "/", label: "Home" },
      { path: "/timetable", label: "Timetable" },
      { path: "/venue", label: "Venue" },
      { path: "/event", label: "Events" },
      { path: "/about-us", label: "About Us" },
      { path: "/contact", label: "Contact Us" },
    ],
    socialLinks: [
      {
        name: "Youtube",
        url: "https://www.youtube.com/@studiovfitnessclub",
        icon: "Youtube"
      },
      {
        name: "Instagram",
        url: "https://instagram.com/studiov4u_hq?igshid=YmMyMTA2M2Y=",
        icon: "Instagram"
      },
      {
        name: "Facebook",
        url: "https://www.facebook.com/studiov4u?mibextid=LQQJ4d",
        icon: "Facebook"
      },
      {
        name: "Waze",
        url: "https://waze.com/ul/hw284r589x",
        icon: "Waze"
      },
      {
        name: "Tiktok",
        url: "https://www.tiktok.com/@studiov4u?_t=8b9umdv5p6v&_r=1",
        icon: "Tiktok"
      }
    ],
    copyright: {
      year: "2026",
      text: "Copyright © 2026 Studio V Fitness Centre. 202503271376 (TR0329724-P). All rights reserved.",
      developer: {
        text: "STUDIO V FITNESS CLUB",
        url: "https://www.studiovfitnessclub.com/"
      }
    },
    legalLinks: [
    ]
  };
}

